import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = { class: "mt-0" }
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = { class: "relative" }

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupAffiliateNavbar = _resolveComponent("PopupAffiliateNavbar")
  const _component_CardWithdraw = _resolveComponent("CardWithdraw")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupAffiliateNavbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CardWithdraw, {
          detail: _ctx.walletAffiliate,
          onWithdraw: _cache[0] || (_cache[0] = () => _ctx.handleWithdraw('walletAffiliate'))
        }, null, 8 /* PROPS */, ["detail"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          for: "search",
          class: "mb-2 text-sm font-medium text-gray-900 sr-only"
        }, "affiliate link", -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none" }, [
            _createElementVNode("svg", {
              class: "w-4 h-4 text-white",
              "aria-hidden": "true",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961"
              })
            ])
          ], -1 /* HOISTED */)),
          _withDirectives(_createElementVNode("input", {
            type: "url",
            id: "search",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.affiliateLink.link) = $event)),
            class: "block w-full p-4 ps-10 text-sm text-white bg-zinc-500 border-2 border-green-600 focus:border-green-600 focus:ring-2 focus:ring-green-500 focus:outline-none rounded-lg",
            placeholder: "กำลังโหลด...",
            readonly: "",
            required: ""
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, _ctx.affiliateLink.link]
          ]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
            type: "button",
            class: "text-white absolute end-2.5 bottom-1/2 translate-y-1/2 cursor-pointer bg-black/90 hover:bg-black focus:ring-4 focus:outline-none focus:ring-black font-medium rounded-lg text-sm px-2 py-1"
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              class: "inline w-4 h-4 text-gray-50",
              "aria-hidden": "true",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                stroke: "currentColor",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"
              })
            ], -1 /* HOISTED */),
            _createElementVNode("span", { class: "hidden md:inline" }, "คัดลอก", -1 /* HOISTED */)
          ]))
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}